 let CustomMealBuilder = (function(){
    // this.config = {}
    function CustomMealBuilder(container, mealDrawer){
        this.container = container
        this.mealDrawer = mealDrawer
        this.selectors = {
          currentProteinMacro: ".cm-macros__info [data-macros__protein]",
          currentCalMacro: ".cm-macros__info [data-macros__cal]",
          currentFatsMacro: ".cm-macros__info [data-macros__fat]",
          currentCarbMacro: ".cm-macros__info [data-macros__carb]",
          doubleProtein: "#doubleProtein",
          doubleCarb: "#doubleCarb",
          doubleVeg: "#doubleVeg",
          mealSelectors: ".meal-selectors",
          drawerMealsWrapper: ".drawer-meals-wrapper",
          repeatMealButton: ".meal-selector-controls .btn.repeat-meal",
          nextMealButton: ".meal-selector-controls .btn.next-meal",
        };
        this.config = {};
        this.init();
    }
    // this.init();
    CustomMealBuilder.prototype = Object.assign({}, CustomMealBuilder.prototype, {
        init: function() {
            this.proteinRadios          = this.container.querySelectorAll('[name="protein_option_radio"]')
            this.carbRadios             = this.container.querySelectorAll('[name="carb_option_radio"]')
            this.vegRadios              = this.container.querySelectorAll('[name="veg_option_radio"]')
            this.doubleProtein          = this.container.querySelector(this.selectors.doubleProtein)
            this.doubleCarb             = this.container.querySelector(this.selectors.doubleCarb )
            this.doubleVeg              = this.container.querySelector(this.selectors.doubleVeg)
            this.repeatMealButton       = this.container.querySelector(this.selectors.repeatMealButton);
            this.nextMealButton         = this.container.querySelector(this.selectors.nextMealButton)

            this.currentTotalMacros = {
                cal: 0,
                fats:0,
                protein: 0,
                carb:0,
                userChosen : false
            }
            const emptyMacro = {
                cal: 0,
                fats: 0,
                protein: 0,
                carb: 0
            };
            this.protein = emptyMacro , this.carb = emptyMacro , this.veg = emptyMacro;
            this.mealModifiers = {
                doubleProtein: false,
                doubleCarb : false,
                doubleVeg: false
            }
            this.enableRepeatMealButton = false;
            this.proteinError = false;
            this.carbError = false;
            this.vegError = false;
            this.bindCallbacks()
            this.bindEvents()
        },
        bindCallbacks: function() {
            this.proteinRadioBound               = (evt) => this.setMacro('protein', evt);
            this.carbRadioBound                  = (evt) => this.setMacro('carb', evt);
            this.vegRadioBound                   = (evt) => this.setMacro('veg', evt);
            this.doubleProteinBound              = (evt) => this.updateModifiers('doubleProtein', evt)
            this.doubleCarbBound                 = (evt) => this.updateModifiers('doubleCarb', evt)
            this.doubleVegBound                  = (evt) => this.updateModifiers('doubleVeg', evt)
            this.repeatMealBound                 = ()    => this.rebuildLastMeal()
            this.nextMealBound                   = ()    => this.buildMeal()

        },
        bindEvents: function(){
            this.proteinRadios.forEach((proteinRadio) =>{
                proteinRadio.addEventListener('click', this.proteinRadioBound, false)
            })
            this.carbRadios.forEach((carbRadio) =>{
                carbRadio.addEventListener('click', this.carbRadioBound, false)
            })
            this.vegRadios.forEach((vegRadio) =>{
                vegRadio.addEventListener('click', this.vegRadioBound, false)
            })

            this.doubleProtein.addEventListener('click', this.doubleProteinBound, false)
            this.doubleCarb.addEventListener('click', this.doubleCarbBound, false)
            this.doubleVeg.addEventListener('click', this.doubleVegBound, false)

            this.repeatMealButton.addEventListener('click', this.repeatMealBound, false);
            this.nextMealButton.addEventListener('click', this.nextMealBound, false);
        },
        setMacro: function(macroType, evt) {
            let selectedEl = evt.currentTarget;
            let selectedOptionEle = selectedEl.closest('.option')
            if(selectedEl.dataset.option != this[macroType].name) {
                this[macroType] = {
                    name: selectedEl.dataset.option,
                    cal: Number(selectedEl.dataset.cal),
                    fats: Number(selectedEl.dataset.fat),
                    protein: Number(selectedEl.dataset.protein),
                    carb: Number(selectedEl.dataset.carb),
                    userChosen: true
                };
                this.updateError(macroType, false)
                this[`${macroType}Error`] = false;
                this.calcMacros();
            }else{
                selectedEl.checked = false
                this[macroType] = {
                    name: null,
                    cal: 0,
                    fats: 0,
                    protein: 0,
                    carb: 0
                };
                this.calcMacros();
                selectedOptionEle.classList.remove("option-active");
            }


        },
        calcMacros: function(){
            this.currentTotalMacros.cal = this.protein.cal + this.carb.cal + this.veg.cal + ((this.mealModifiers.doubleProtein)? this.protein.cal : 0) + ((this.mealModifiers.doubleCarb)? this.carb.cal : 0) + ((this.mealModifiers.doubleVeg)? this.veg.cal : 0)
            this.currentTotalMacros.protein = this.protein.protein + this.carb.protein + this.veg.protein + ((this.mealModifiers.doubleProtein)? this.protein.protein : 0) + ((this.mealModifiers.doubleCarb)? this.carb.protein : 0) + ((this.mealModifiers.doubleVeg)? this.veg.protein : 0)
            this.currentTotalMacros.carb = this.protein.carb + this.carb.carb + this.veg.carb + ((this.mealModifiers.doubleProtein)? this.protein.carb : 0) + ((this.mealModifiers.doubleCarb)? this.carb.carb : 0) + ((this.mealModifiers.doubleVeg)? this.veg.carb : 0)
            this.currentTotalMacros.fats = this.protein.fats + this.carb.fats + this.veg.fats + ((this.mealModifiers.doubleProtein)? this.protein.fats : 0) + ((this.mealModifiers.doubleCarb)? this.carb.fats : 0) + ((this.mealModifiers.doubleVeg)? this.veg.fats : 0)
            this.updateCurrentMacros()
        },
        updateCurrentMacros: function(){
            this.container.querySelector(this.selectors.currentProteinMacro).textContent = this.currentTotalMacros.protein + 'g'
            this.container.querySelector(this.selectors.currentCalMacro).textContent = this.currentTotalMacros.cal
            this.container.querySelector(this.selectors.currentFatsMacro).textContent = this.currentTotalMacros.fats + 'g'
            this.container.querySelector(this.selectors.currentCarbMacro).textContent = this.currentTotalMacros.carb + 'g'
        },
        updateModifiers: function (modifierType, evt){
            if (evt.target.tagName === 'INPUT') {
                this.mealModifiers[modifierType] = evt.target.checked;
                this.calcMacros()
            }else {

                const checkbox = evt.target.querySelector('input[type="checkbox"]');
                if (checkbox) {
                    checkbox.checked = !checkbox.checked; // Toggle the checkbox state
                    this.mealModifiers[modifierType] = checkbox.checked;
                    this.calcMacros()
                }

            }
        },
        updateError: function(option, isError = true, customText = undefined){
            let optionEle = this.container.querySelector(`[data-option-${option}]`)
            if(isError){
                optionEle.classList.add('error')
            }else{
                optionEle.classList.remove('error')
            }
            this.container.querySelector(`[data-option-${option}] .option-error`).style.display = (isError)? 'block' : 'none'

             const errorDiv = this.container.querySelector(
               `[data-option-${option}] .option-error`
             );
             errorDiv.style.display = isError ? "block" : "none";
            if(customText && isError){
                this.container.querySelector(`[data-option-${option}] .option-error`).textContent = customText
                errorDiv.querySelector("h5").textContent = customText;

            }
            this[`${option}Error`] = isError;

        },
        buildMeal: function() {
            this.validateMeal()
            if(!this.proteinError && !this.carbError && !this.vegError && !this.mealError) {
                const meal = {
                    protein: this.protein,
                    carb: this.carb,
                    veg: this.veg,
                    modifiers: this.mealModifiers,
                    macros: this.currentTotalMacros
                };
                this.mealDrawer.addMeal(meal);
                if (!this.enableRepeatMealButton) {
                    this.enableRepeatMealButton = true;
                    this.repeatMealButton.disabled = false
                }

                //clear selections
                this.container.querySelectorAll('input[type="radio"]').forEach((radio) => {
                    radio.checked = false;
                });
                this.container.querySelectorAll('input[type="checkbox"]').forEach((radio) => {
                    radio.checked = false;
                });
                this.resetMeal()
                this.calcMacros()
            }
        },
        resetMeal: function(){
            this.currentTotalMacros = {
                cal: 0,
                fats:0,
                protein: 0,
                carb:0,
                userChosen : false
            }
            const emptyMacro = {
                cal: 0,
                fats: 0,
                protein: 0,
                carb: 0
            };
            this.protein = emptyMacro , this.carb = emptyMacro , this.veg = emptyMacro;
            this.mealModifiers = {
                doubleProtein: false,
                doubleCarb : false,
                doubleVeg: false
            }
            this.proteinError = false;
            this.carbError = false;
            this.vegError = false;


        },
        validateMeal: function() {
            const { protein, carb, veg, mealModifiers } = this;

            // Rule: All macros (protein, carb, and veg) must be selected with no modifiers
            const isAllMacrosValid = protein.userChosen && carb.userChosen && veg.userChosen &&
                !mealModifiers.doubleCarb && !mealModifiers.doubleVeg && !mealModifiers.doubleProtein;

            // Rule: Only protein and carb are selected, veg is not, and one of doubleCarb or doubleProtein is selected
            const isProteinAndCarbWithModifierValid =
                protein.userChosen && carb.userChosen && !veg.userChosen &&
                ((mealModifiers.doubleCarb && !mealModifiers.doubleVeg && !mealModifiers.doubleProtein) ||
                    (mealModifiers.doubleProtein && !mealModifiers.doubleCarb && !mealModifiers.doubleVeg));

            // Rule: Only protein and veg are selected, carb is not, and one of doubleVeg or doubleProtein is selected
            const isProteinAndVegWithModifierValid =
                protein.userChosen && veg.userChosen && !carb.userChosen &&
                ((mealModifiers.doubleVeg && !mealModifiers.doubleCarb && !mealModifiers.doubleProtein) ||
                    (mealModifiers.doubleProtein && !mealModifiers.doubleCarb && !mealModifiers.doubleVeg));

            // Check for any invalid combination of macros and modifiers
            const isInvalidCombination = (
                // Invalid if only protein and veg are selected
                (protein.userChosen && veg.userChosen && !carb.userChosen && !mealModifiers.doubleVeg && !mealModifiers.doubleProtein) ||
                // Invalid if protein, doubleCarb, and veg are selected
                (protein.userChosen && veg.userChosen && !carb.userChosen && mealModifiers.doubleCarb) ||
                // Invalid if protein, carb, and veg are selected with any modifiers
                (protein.userChosen && carb.userChosen && !!veg.userChosen &&
                    (mealModifiers.doubleCarb || mealModifiers.doubleVeg || mealModifiers.doubleProtein))
            );

            // If a valid option is found, clear any errors; otherwise, set errors
            if ( isAllMacrosValid  || isProteinAndCarbWithModifierValid || isProteinAndVegWithModifierValid) {
                this.mealError = false;
               ["protein", "carb", "veg"].forEach((macroType) => {
                 this.updateError(
                   macroType,
                   false,
                   `Please Choose a ${macroType}`
                 );
               });
                ['doubleProtein', 'doubleCarb', 'doubleVeg'].forEach((modifier) => {
                    this.updateError(modifier, false);
                });
            } else {
                this.mealError = true;
                // Update errors for invalid modifier combinations
                if(!isAllMacrosValid && (mealModifiers.doubleCarb || mealModifiers.doubleVeg || mealModifiers.doubleProtein)) {
                    ['doubleProtein', 'doubleCarb', 'doubleVeg'].forEach((modifier) => {
                        if(mealModifiers[modifier] === true) {

                            let option = '';
                            if(modifier  == 'doubleProtein') {
                                option = 'protein';
                            } else if(modifier == 'doubleCarb') {
                                option = 'carb';
                            } else if(modifier == 'doubleVeg') {
                                option = 'veg';
                            }
                            this.updateError(option, true, 'You cannot choose to double your portion if you have chosen all 3 PROTEIN, CARBS and VEG.');
                        }

                    });
                } else if (isInvalidCombination) {
                    if (mealModifiers.doubleCarb) this.updateError('doubleCarb');
                    if (mealModifiers.doubleVeg) this.updateError('doubleVeg');
                    if (mealModifiers.doubleProtein) this.updateError('doubleProtein');
                } else {


                    // Update errors for macros if none of the valid configurations are met
                    ['protein', 'carb', 'veg'].forEach((macroType) => {
                        if (!this[macroType].userChosen) {
                            this.updateError(macroType);
                        } else {
                            this.updateError(macroType, false);
                        }
                    });
                }
            }
        },
        rebuildLastMeal: function() {
            const lastMeal = this.mealDrawer.getLastMeal();
            if (lastMeal) {
                this.protein = lastMeal.protein;
                this.carb = lastMeal.carb;
                this.veg = lastMeal.veg;
                this.mealModifiers = lastMeal.modifiers;
                this.currentTotalMacros = lastMeal.macros;
                this.updateCurrentMacros();
                this.buildMeal()
            }
        }
    })
    return CustomMealBuilder;
})();


let CustomMealDrawer = (function() {
    function CustomMealDrawer(container) {
        this.container = container;
        this.meals = [];
        this.selectors = {
          mealSelectors: ".meal-selectors",
          drawerMealsWrapper: "#custom-meal-drawer .drawer-meals-wrapper",
          repeatMealButton: ".meal-selector-controls .btn.repeat-meal",
          currentMealCounter: ".current-meal-amount",
          totalProtein: ".cm-macros__info [data-macros__total-protein]",
          totalCalories: ".cm-macros__info [data-macros__total-cal]",
          totalFats: ".cm-macros__info [data-macros__total-fat]",
          totalCarbs: ".cm-macros__info [data-macros__total-carb]",
          totalCost: ".drawer-meal-total [data-total-cost]",
          removeButton: ".remove-meal",
          drawerCollapsed: ".meal-progress",
          progressBarSelector: ".progress-bar",
          cmProduct: "#product-variant",
          checkoutButton: ".btn.checkout",
          saveMacroButton: ".btn.saveMacro",
          deliveryDate: "#deliveryDate",
        };
        this.productVariants = JSON.parse(document.querySelector(this.selectors.cmProduct).innerHTML);
        this.doubleProteinProductId = 49166576582960;
        this.doubleCarbProductId = 49166577271088;
        this.doubleVegProductId = 49166577566000;
        this.doubleProteinCount = 0;
        this.doubleCarbCount = 0;
        this.doubleVegCount = 0;
        this.totalPrice = 0;
        this.basePrice = 19.50
        this.doubleProteinPrice  = 6.25;
        this.doubleCarbPrice = 4.00
        this.doubleVegPrice  = 4.00
        this.loadMealsFormStorage()
        this.checkRepeatMealAllowed()
        this.updateCurrentMealCounters()
        this.bindCallbacks()
        this.bindEvents()
        this.updateTotalMealMetrics();
        this.checkValidNumberOfMeals()
        this.calcTotalPrice()
        this.collapseDrawer()
        this.setDeliveryDate()
    }

    CustomMealDrawer.prototype = {
      bindEvents: function () {
        this.container
          .querySelectorAll(this.selectors.removeButton)
          .forEach((removeButton) => {
            removeButton.addEventListener(
              "click",
              this.removeButtonBound,
              false
            );
          });
        this.container
          .querySelector(this.selectors.drawerCollapsed)
          .addEventListener("click", this.drawerCollapsedBound, false);
        this.container
          .querySelectorAll(this.selectors.checkoutButton)
          .forEach((checkoutButton) => {
            checkoutButton.addEventListener(
              "click",
              () => this.addMealToCart(),
              false
            );
          });
        this.container
          .querySelector(this.selectors.saveMacroButton)
          .addEventListener("click", this.saveMacroButtonBound, false);
      },
      bindCallbacks: function () {
        this.removeButtonBound = (evt) => this.removeMeal(evt);
        this.drawerCollapsedBound = (evt) => this.collapseDrawer(evt);
        this.saveMacroButtonBound = (evt) => this.createMacroTextFile(evt);
      },

      addMeal: function (meal) {
        this.meals.push(meal);
        this.floatMealToDrawer(meal, this.meals.length);
        this.updateMealsInStorage();
        this.updateCurrentMealCounters();
        this.updateTotalMealMetrics();
        this.calcTotalPrice();
      },

      findMatchingVariant: function (selectedOptions) {
        return this.productVariants.find((variant) => {
          return selectedOptions.every((selectedOption, index) => {
            return variant.options[index] === selectedOption;
          });
        });
      },
      calcTotalPrice: function () {
        this.totalPrice = 0;
        this.meals.forEach((meal) => {
          this.totalPrice +=
            this.basePrice +
            (meal.modifiers.doubleProtein ? this.doubleProteinPrice : 0) +
            (meal.modifiers.doubleCarb ? this.doubleCarbPrice : 0) +
            (meal.modifiers.doubleVeg ? this.doubleVegPrice : 0);
        });
        this.container.querySelector(this.selectors.totalCost).textContent =
          this.totalPrice.toFixed(2);
      },
      buildProductData: function (meals) {
        const productData = [];

        meals.forEach((meal) => {
          const selectedOptions = [
            meal.protein.name,
            meal.carb.name,
            meal.veg.name,
          ];

           // const matchingVariant = this.findMatchingVariant(selectedOptions);
              if(meal.modifiers.doubleProtein){
                  this.doubleProteinCount++
              }
             if(meal.modifiers.doubleCarb){
                 this.doubleCarbCount++
             }
             if(meal.modifiers.doubleVeg){
                 this.doubleVegCount++
             }
             var mealData = {
                 id: 49150990319920,
                 quantity: 1,
                 properties: {
                     Protein: meal.protein.name,
                     Carb: meal.carb.name,
                     Veg: meal.veg.name
                 }
             }
            if (meal.modifiers.doubleProtein) {
               mealData.properties.DoubleProtein = meal.modifiers.doubleProtein
            }
            if(meal.modifiers.doubleCarb) {
               mealData.properties.DoubleCarb = meal.modifiers.doubleCarb
            }
            if(meal.modifiers.doubleVeg) {
              mealData.properties.DoubleVeg = meal.modifiers.doubleVeg
            }
             productData.push(mealData);
         });

        if (this.doubleProteinCount > 0) {
          productData.push({
            id: this.doubleProteinProductId,
            quantity: this.doubleProteinCount,
          });
        }
        if (this.doubleCarbCount > 0) {
          productData.push({
            id: this.doubleCarbProductId,
            quantity: this.doubleCarbCount,
          });
        }
        if (this.doubleVegCount > 0) {
          productData.push({
            id: this.doubleVegProductId,
            quantity: this.doubleVegCount,
          });
        }

        return productData;
      },

      addMealToCart: function () {
        const productData = this.buildProductData(this.meals);
        const checkoutButton = document.querySelector(
          this.selectors.checkoutButton
        );
        if (productData.length > 0) {
          checkoutButton.classList.add("loading");
          const spanLoader = checkoutButton.appendChild(
            document.createElement("span")
          );
          spanLoader.classList.add("spinner");
          fetch("/cart/add.js", {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify({ items: productData }),
          })
            .then((response) => response.json())
            .then((data) => {
              if (
                data.items &&
                Array.isArray(data.items) &&
                data.items.length > 0
              ) {
                localStorage.removeItem("custom-meals");
                window.location.href = "/cart";
              } else {
                console.error("Error adding items to cart:", data);
              }
            })
            .catch((error) => {
              console.error("Error:", error);
            })
            .finally(() => {
              checkoutButton.classList.remove("loading");
              spanLoader.remove();
            });
        } else {
          console.error("No valid meals to add to cart.");
        }
      },

      getLastMeal: function (meal) {
        return this.meals.length ? this.meals[this.meals.length - 1] : null;
      },
      updateMealsInStorage: function () {
        localStorage.removeItem("custom-meals");
        localStorage.setItem("custom-meals", JSON.stringify(this.meals));
        this.checkValidNumberOfMeals();
      },
      checkValidNumberOfMeals: function (meal) {
        if (this.meals.length < 6) {
          document
            .querySelectorAll(this.selectors.checkoutButton)
            .forEach((checkoutButton) => (checkoutButton.disabled = true));
          document
            .querySelectorAll(this.selectors.checkoutButton)
            .forEach((checkoutButton) =>
              checkoutButton.classList.add("disabled")
            );
        } else {
          document
            .querySelectorAll(this.selectors.checkoutButton)
            .forEach((checkoutButton) => (checkoutButton.disabled = false));
          document
            .querySelectorAll(this.selectors.checkoutButton)
            .forEach((checkoutButton) =>
              checkoutButton.classList.remove("disabled")
            );
        }
      },
      loadMealsFormStorage: function () {
        const mealsFromStorage = localStorage.getItem("custom-meals");
        if (mealsFromStorage) {
          this.meals = JSON.parse(mealsFromStorage);
          this.meals.forEach((meal, index) => {
            const floatingMeal = this.buildMealEle(meal, index + 1);
            floatingMeal.style.opacity = "1";
            document
              .querySelector(this.selectors.drawerMealsWrapper)
              .appendChild(floatingMeal);
          });
        }
        this.updateTotalMealMetrics();
      },
      updateCurrentMealCounters: function () {
        document
          .querySelectorAll(this.selectors.currentMealCounter)
          .forEach((counter) => {
            counter.textContent = String(this.meals.length);
          });
        const progress = (this.meals.length / 6) * 100 + "%";
        document
          .querySelector(this.selectors.progressBarSelector)
          .style.setProperty("--progress", progress);
      },
      updateTotalMealMetrics: function () {
        this.totalMetrics = {
          calories: 0,
          carbs: 0,
          fats: 0,
          protein: 0,
        };

        // Sum up the macros from all meals
        this.meals.forEach((meal) => {
          this.totalMetrics.calories += Number(meal.macros.cal);

          this.totalMetrics.carbs += Number(meal.macros.carb);

          this.totalMetrics.fats += Number(meal.macros.fats);

          this.totalMetrics.protein += Number(meal.macros.protein);
        });

        // Update the UI with the new totals
        document.querySelector(this.selectors.totalCalories).textContent =
          this.totalMetrics.calories;
        document.querySelector(this.selectors.totalCarbs).textContent =
          String(this.totalMetrics.carbs) + "g";
        document.querySelector(this.selectors.totalFats).textContent =
          String(this.totalMetrics.fats) + "g";
        document.querySelector(this.selectors.totalProtein).textContent =
          String(this.totalMetrics.protein) + "g";
      },
      floatMealToDrawer: function (meal, index) {
        const mealSelectors = document
          .querySelector(this.selectors.mealSelectors)
          .getBoundingClientRect();
        const drawerWrapper = document
          .querySelector(this.selectors.drawerMealsWrapper)
          .getBoundingClientRect();

        // Create a new floating div for the meal
        const floatingMeal = this.buildMealEle(meal, index);
        document.body.appendChild(floatingMeal);

        floatingMeal.style.position = "absolute";
        floatingMeal.style.left = `${
          mealSelectors.left + window.scrollX + mealSelectors.width / 2
        }px`;
        floatingMeal.style.top = `${
          mealSelectors.top + window.scrollY + mealSelectors.height / 2
        }px`;
        floatingMeal.style.opacity = "0.2";
        floatingMeal.style.transform = "scale(4)";
        floatingMeal.style.transition = "all 1s ease";

        const translateY = drawerWrapper.top - mealSelectors.top;
        const translateX = drawerWrapper.left - mealSelectors.left;

        setTimeout(() => {
          floatingMeal.style.transform = `translate(${translateX}px, ${translateY}px) scale(1)`;
          floatingMeal.style.opacity = "1";
        }, 100);

        setTimeout(() => {
          document
            .querySelector(this.selectors.drawerMealsWrapper)
            .appendChild(floatingMeal);
          floatingMeal.style = "";
          floatingMeal.style.opacity = "1";
        }, 800);
      },
      buildMealEle: function (meal, index) {
        const floatingMeal = document.createElement("div");
        floatingMeal.classList.add("drawer-meal");
        floatingMeal.style = "";

        let description = "";

        if (meal.modifiers.doubleProtein) {
          description += "<p>Double<br> Protein</p>";
        }

        if (meal.modifiers.doubleCarb) {
          description += "<p>Double<br> Carbs</p>";
        }

        if (meal.modifiers.doubleVeg) {
          description += "<p>Double<br> Veg</p>";
        }
        if (
          !meal.modifiers.doubleProtein &&
          !meal.modifiers.doubleCarb &&
          !meal.modifiers.doubleVeg
        ) {
          description += "<p>No Additional</p>";
        }

        floatingMeal.innerHTML = `
            <div class="remove-meal" data-meal-index="${index}">
                <svg width="11" height="9" viewBox="0 0 11 9" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M7.71814 9L5.35982 6.24359L3.28186 9H0.0824588L3.7931 4.42308L0 0H3.28186L5.6072 2.71795L7.65217 0H10.8516L7.17391 4.53846L11 9H7.71814Z" fill="#121212" fill-opacity="0.75"/>
                </svg>
            </div>
            <div class="drawer-meal__title" data-meal-counter="${index}">
                <h4>${meal.protein.name} ${
          meal.carb.userChosen ? "/ " + meal.carb.name : ""
        } ${meal.veg.userChosen ? "/ " + meal.veg.name : ""}</h4>
            </div>
            <div class="drawer-meal__macros">
                <p>Protein: <span class="drawer-meal-choice__protein">${
                  meal.macros.protein
                }</span></p>
                <p>Carb: <span class="drawer-meal-choice__carb">${
                  meal.macros.carb
                }</span></p>
                <p>Fat: <span class="drawer-meal-choice__fat">${
                  meal.macros.fats
                }</span></p>
                <p>Cal: <span class="drawer-meal-choice__cal">${
                  meal.macros.cal
                }</span></p>
            </div>
            <div class="drawer-meal__description">
                <p>Description:</p>
                <div class="modifiers">
                 ${description}
                </div>
            </div>
        `;
        //add event listener to remove meal
        floatingMeal
          .querySelector(".remove-meal")
          .addEventListener("click", this.removeButtonBound, false);
        return floatingMeal;
      },

      checkRepeatMealAllowed: function () {
        if (this.meals.length > 0) {
          document.querySelector(
            this.selectors.repeatMealButton
          ).disabled = false;
        }
      },
      removeMeal: function (evt) {
        const mealIndex = evt.currentTarget.parentElement.dataset.mealIndex;
        this.meals.splice(mealIndex, 1);
        evt.currentTarget.parentElement.remove();
        this.updateMealsInStorage();
        this.updateTotalMealMetrics();
        this.updateCurrentMealCounters();
        this.calcTotalPrice();
      },

      collapseDrawer: function (evt) {
        const drawerMealsWrapper = document.querySelector(
          this.selectors.drawerMealsWrapper
        );
        const arrowIcon = document.querySelector(
          this.selectors.drawerCollapsed + " .arrow-icon"
        );

        drawerMealsWrapper.classList.toggle("collapsed");
        arrowIcon.classList.toggle("rotate");
      },

      createMacroTextFile: function () {
        const today = new Date(Date.now());
        let mealMacros = ``;
        this.meals.forEach((meal, index) => {
          mealMacros += `${this.parseMealMacros(meal)}\n`;
        });
        const textContent = `Protein Chefs Custom Meal Macros, ${
          today.toISOString().split("T")[0]
        } \n ${mealMacros} `;

        const blob = new Blob([textContent], { type: "text/plain" });
        const url = URL.createObjectURL(blob);

        const link = document.createElement("a");
        link.href = url;
        link.download = `Protein-Chefs-Macros-${
          today.toISOString().split("T")[0]
        } \n\n `;
        link.click();
      },
      setDeliveryDate: function () {
        const savedDate = sessionStorage.getItem("saved_delivery_date");
        if (!savedDate) return;

        updateCartAttributes(savedDate);

        function formatDate(dateString) {
          try {
            const [, month, day, year] = dateString.split(" ");
            const date = new Date(`${month} ${day} ${year}`);
            if (isNaN(date)) return null;

            const yyyy = date.getFullYear();
            const mm = String(date.getMonth() + 1).padStart(2, "0");
            const dd = String(date.getDate()).padStart(2, "0");
            return `${yyyy}-${mm}-${dd}`;
          } catch (error) {
            console.error("Error formatting date:", error);
            return null;
          }
        }

        const deliveryDate = formatDate(savedDate);
        const dateInput = document.querySelector("#deliveryDate");

        if (deliveryDate && dateInput) {
          dateInput.value = deliveryDate;
          dateInput.setAttribute("min", deliveryDate);
        }
      },
      parseMealMacros(meal) {
        const title = `${meal.protein.name} ${
          meal.carb.userChosen ? "/ " + meal.carb.name : ""
        } ${meal.veg.userChosen ? "/ " + meal.veg.name : ""}`;
        const macros = `Protein: ${meal.macros.protein ?? 0}g\n Carbs: ${
          meal.macros.carbs ?? 0
        }g\n Fats ${meal.macros.fats ?? 0}g\n Calories: ${
          meal.macros.cal ?? 0
        }`;
        return `${title}\n ${macros} \n\n`;
      },
    };

    return CustomMealDrawer;
})();

document.addEventListener("DOMContentLoaded", function () {
  const mealDrawer = new CustomMealDrawer(
    document.querySelector("#custom-meal-drawer")
  );
  const mealBuilder = new CustomMealBuilder(
    document.querySelector("#cm_selector"),
    mealDrawer
  );

  

  // mealBuilder.init();
});